export const FIREBASE_PROJECT_ID = process.env.FIREBASE_PROJECT_ID
export const FUNCTIONS_REGION = process.env.FUNCTIONS_REGION
